export enum User__Role {
  L1Agent = 'L1_AGENT',
  L2Agent = 'L2_AGENT',
}
